/* eslint-disable max-len */
import * as React from 'react';

const DownArrow = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.1205 19.5L12.5937 19.5C12.1411 19.5 11.8393 19.2563 11.8393 18.8906C11.8393 18.525 12.1411 18.2813 12.5937 18.2813L15.3098 18.2813L9.425 13.5281C9.12321 13.2844 9.12321 12.9188 9.425 12.675L12.6692 10.0547L7.53884 5.91094C7.38795 5.78906 7.3125 5.66719 7.3125 5.48437C7.3125 5.30156 7.38795 5.17969 7.53884 5.05781C7.84063 4.81406 8.2933 4.81406 8.59509 5.05781L14.2536 9.62813C14.5554 9.87188 14.5554 10.2375 14.2536 10.4813L11.0094 13.1016L16.3661 17.4281L16.3661 15.2344C16.3661 14.8688 16.6679 14.625 17.1205 14.625C17.5732 14.625 17.875 14.8688 17.875 15.2344L17.875 18.8906C17.875 18.9516 17.875 19.0734 17.7996 19.1344C17.7241 19.2563 17.5732 19.3781 17.4223 19.4391C17.3469 19.5 17.196 19.5 17.1205 19.5Z"
      fill="#DD4E47"
    />
  </svg>
);
export default DownArrow;
